<div class="spinner-banner">
  <c-progress [value]="progressValue" height="20px" class="custom-progress"></c-progress>
</div>